module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepTwo"
  }, [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 1
    }
  }), _vm._v(" "), (_vm.isCommon) ? _c('div', {
    staticClass: "stepTwo-content"
  }, [_c('p', {
    staticClass: "stepTow-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "md-alert"
    }
  }), _vm._v(" 检测到您在我校已绑定手机号 " + _vm._s(_vm.phoneNum) + "，请使用短信验证码激活。如预置手机号有误，请“钉钉”联系信息中心阮月光老师。")], 1), _vm._v(" "), _c('div', {
    staticClass: "stepTwo-form"
  }, [_c('p', {
    staticClass: "stepTwo-myphone"
  }, [_vm._v("手机号: " + _vm._s(_vm.phoneNum))]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisable2
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getMobileCode2.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.getText2))])], 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.handleSubmit2
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isUpload) ? _c('div', {
    staticClass: "stepTwo-content"
  }, [_c('p', {
    staticClass: "stepTow-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "md-alert"
    }
  }), _vm._v("账户未绑定手机号，请联系管理员")], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abfdf756!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/stepTwo.vue
// module id = 203
// module chunks = 0